import { useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'sports-hq-match-sort';
const valid = value => value === 'time' || value === 'league';
const localChoice = () => {
  try { return (window.SportsHQSettings || window.localStorage).getItem(STORAGE_KEY); } catch { return null; }
};
const saveLocal = value => {
  try { (window.SportsHQSettings || window.localStorage).setItem(STORAGE_KEY, value); return true; } catch { return false; }
};
const request = async (method = 'GET', sort_order) => {
  const response = await fetch('/sportsim/api/auth/match-sort', {
    method, credentials: 'same-origin', cache: 'no-store',
    ...(method === 'PUT' ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sort_order }) } : {}),
  });
  if (!response.ok) throw new Error(String(response.status));
  return response.json();
};

export default function useMatchSort() {
  const [savedOrder, setSavedOrder] = useState(() => valid(localChoice()) ? localChoice() : 'league');
  const [ready, setReady] = useState(false);
  const [notice, setNotice] = useState('');
  const authenticated = useRef(null);
  const queue = useRef(Promise.resolve());
  const version = useRef(0);
  useEffect(() => {
    let active = true;
    if(window.SportsHQSettings){const sync=()=>{setSavedOrder(valid(localChoice())?localChoice():'league');authenticated.current=window.SportsHQSettings.authenticated;setReady(true);};sync();window.addEventListener('sports-hq-settings-state',sync);return ()=>window.removeEventListener('sports-hq-settings-state',sync);}
    request().then(data => {
      if (!active) return;
      authenticated.current = data.authenticated;
      if (data.authenticated) setSavedOrder(valid(data.sort_order) ? data.sort_order : 'league');
      setReady(true);
    }).catch(() => { if (active) setReady(true); });
    return () => { active = false; };
  }, []);

  const saveOrder = value => {
    setSavedOrder(value);
    setNotice('');
    if (authenticated.current === false) {
      if (!saveLocal(value)) setNotice('Sorteringen kunde inte sparas på den här enheten.');
      return;
    }
    if(window.SportsHQSettings){saveLocal(value);return;}
    const current = ++version.current;
    // Serialize writes so a slower earlier selection cannot overwrite the latest choice.
    queue.current = queue.current.catch(() => {}).then(() => request('PUT', value));
    queue.current.catch(error => {
      if (current !== version.current) return;
      if (error.message === '401') {
        authenticated.current = false;
        if (!saveLocal(value)) setNotice('Sorteringen kunde inte sparas på den här enheten.');
      } else {
        setNotice('Sorteringen kunde inte sparas till kontot. Välj igen för att försöka på nytt.');
      }
    });
  };
  return { savedOrder, saveOrder, ready, notice };
}
